import React from 'react';
import Layout from '../../components/layout/layout';

import styles from "./style.module.scss";
import { BASENAME } from "../../constant";


export default function ThankYou() {


    return (
        <Layout
            removeContactForm={true}
        >
            <div className={styles.externalContainer}>
                <div className={styles.card}>
                    <h2 className={styles.title}>La tua sottoscrizione è stata annullata</h2>
                    <img src="site_images/mail-contact.png" className={styles.icon}></img>
                    <p className={styles.text}>Non riceverai più email per questa ricerca.<br></br>
                        Puoi continuare la navigazione o tornare alla nostra <a href="../" className={styles.link}>Homepage</a>
                        .
                    </p>
                    <img src="site_images/logo-contact.png" className={styles.logo}></img>
                </div>
            </div>

        </Layout>
    );
}

